import ButtonLink from 'sd-ui/dist/commonjs/components/ButtonLink/ButtonLink';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import joinNodes from '../../utils/react/joinNodes';

const maxAuthors = 3;

function truncatedList(authors, expandList) {
  const truncatedCount = authors.length - 2;

  const moreAuthorsButton = (
    <ButtonLink icon={null} onClick={expandList} className="more-authors-link" key="more-authors">
      {`+${truncatedCount}`}
    </ButtonLink>
  );

  return {
    nodes: [
      <React.Fragment key="first-author">{authors[0]}</React.Fragment>,
      moreAuthorsButton,
      <React.Fragment key="last-author">{authors[authors.length - 1]}</React.Fragment>,
    ],
    delimiter: ', … ',
    lastDelimiter: ' … , ',
  };
}

function isEtAl(authors) {
  return authors[authors.length - 1]?.props?.children === ' et al.';
}

function expandedList(authors) {
  return {
    nodes: authors,
    delimiter: ', ',
    lastDelimiter: isEtAl(authors) ? '' : ' and ',
  };
}

export default function ArticleAuthors({ authors }) {
  const [listExpanded, setListExpanded] = useState(false);

  const expandList = useCallback(() => {
    setListExpanded(true);
  }, [setListExpanded]);

  const { nodes, delimiter, lastDelimiter } = authors.length > maxAuthors && !listExpanded
    ? truncatedList(authors, expandList)
    : expandedList(authors);

  return (
    <>
      {joinNodes(nodes, delimiter, lastDelimiter)}
    </>
  );
}

ArticleAuthors.propTypes = {
  authors: PropTypes.arrayOf(PropTypes.node).isRequired,
};
